module.exports = __webpack_public_path__ + "static/media/moto_insurance.b9b1849c.svg";